export const TIME_SLOTS = Array.from({ length: 52 }, (_, i) => {
  const total = 9 * 60 + i * 15;
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
});

export const END_TIME_SLOTS = [...TIME_SLOTS.slice(1), '22:00'];

export const isTimeBlocked = (blocks, time) =>
  blocks.some((b) => b.all_day || (b.start_time <= time && time < b.end_time));

export const capitalizeFirst = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const blockLabel = (b) => (b.all_day ? 'Todo el día' : `${b.start_time} – ${b.end_time}`);
